// ** React Imports
import { useContext } from "react";

// ** Redux & Store & Actions
import { useDispatch, useSelector } from "react-redux";
import {
	clearGeolocationInitialData,
	getGeolocationInitialData,
} from "store/modules/global";

// ** Custom Components
import Selector from "components/layout/Selector/Selector";
import GeoLocationElement from "./GeoLocationElement";

// ** Custom Hooks
import useGeolocation from "hooks/useGeolocation";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// ** Styled Components
import { StyledAuthPanelInput } from "containers/Landing/styles/AuthPanelInput.styled";
import {
	StyledAuthPanelInputContainer,
	StyledClickArea,
} from "containers/Landing/styles/AuthPanelInputContainer.styled";
import { AutocompleteInput } from "../styles";

// #####################################################

const LocationActivator = ({
	value,
	label,
	innerRef,
	onFocus,
	handleInputChange,
	inputComponentProps,
	activatorOptions,
	minWidth,
	showDistance,
	alwaysLight,
	isBan,
	isOpen,
	open,
	close,
	isSelected,
	fetchInitialResult,
	setValue,
	layerSide,
	isModal,
	authModalVersion,
}) => {
	const dispatch = useDispatch();

	const { isPhone } = useContext(deviceTypeContext);

	const { noPad, noBold, noMaxWidth, withGeolocation, hideLabel, isLanding } =
		activatorOptions || {};

	const userLocationDataCountryId = useSelector(
		(state) => state?.globalUser?.country
	);
	const userLocationDataUserCountryFromIp = useSelector(
		(state) => state?.globalUser?.countryFromIp
	);

	const geolocationEnable = useSelector(
		(state) => state?.global?.geolocation?.initialData?.success
	);

	const { getGeolocation } = useGeolocation();

	const handleGetGeolocation = () => {
		close();
		setValue("");
		if (!geolocationEnable) {
			getGeolocation(
				(latitude, longitude) => {
					dispatch(getGeolocationInitialData(latitude, longitude));
					open();
				},
				() => {
					fetchInitialResult(
						userLocationDataCountryId ||
							userLocationDataUserCountryFromIp ||
							"pl"
					);
					dispatch(clearGeolocationInitialData());
					open();
				}
			);
		} else {
			setTimeout(() => {
				dispatch(clearGeolocationInitialData());
				open();
			}, 100);
		}
	};

	const withDistanceStyle = showDistance
		? {
				borderTopRightRadius: "0px",
				borderBottomRightRadius: "0px",
				marginRight: "0px",
				borderRightColor: "transparent",
		  }
		: {};

	// #####################################################

	// ** Location Activator na Landingu
	if (inputComponentProps?.register) {
		return (
			<StyledAuthPanelInputContainer
				ref={innerRef}
				isOpen={isOpen}
				$isModal={isModal}
				$authModalVersion={authModalVersion}
			>
				<StyledAuthPanelInput
					value={value}
					onChange={handleInputChange}
					onFocus={onFocus}
					placeholder={label}
					label={label}
					disabled={isBan}
					isOpen={isOpen}
					isSelected={!noBold && isSelected}
					style={{
						width: "100%",
						margin: 0,
					}}
					{...inputComponentProps}
					active={inputComponentProps.active || isOpen}
				/>
				{withGeolocation && (
					<GeoLocationElement
						handleGetGeolocation={handleGetGeolocation}
						alwaysLight={alwaysLight}
						geolocationEnable={geolocationEnable}
						showDistance={showDistance}
						isOpen={isOpen}
						isLanding={isLanding}
					/>
				)}
				<StyledClickArea onClick={onFocus} />
			</StyledAuthPanelInputContainer>
		);
	}

	// ** Location Activator we wszystkich innych miejscach
	return (
		<Selector
			title={!hideLabel && label}
			noPad={noPad}
			noBold={noBold}
			isOpen={isOpen}
			innerRef={innerRef}
			layerSide={layerSide}
			style={{
				/* MARCIN_P: (DZ-1699): flexGrow z 1 na 0 bo przy ładowaniu strony (search/form) był przeskok w szerokości. */
				flexGrow: 0,
				maxWidth: noMaxWidth ? "none" : isPhone ? "none" : "407px",
				minWidth,
				...withDistanceStyle,
			}}
		>
			<Selector.Section
				label={label}
				isSelected={!noBold && isSelected}
				cursorText
				disabled={isBan}
				isOpen={isOpen}
				isPhone={isPhone}
				withOverflowEllipsis={true}
				layerSide={layerSide}
				withCaret={false}
				onMouseDown={onFocus}
				style={{
					paddingRight: withGeolocation ? "42px" : "1rem",
					maxHeight: "var(--dz-sys-input-height)",
					cursor: isBan ? "not-allowed" : null,
					...withDistanceStyle,
				}}
			>
				<AutocompleteInput
					value={value}
					type="text"
					placeholder={label}
					onChange={handleInputChange}
					onFocus={(e) => {
						e.preventDefault();
					}}
					onMouseDown={onFocus}
					isSelected={!noBold && isSelected}
					disabled={isBan}
				/>
			</Selector.Section>

			{withGeolocation && (
				<GeoLocationElement
					handleGetGeolocation={handleGetGeolocation}
					disabled={isBan}
					geolocationEnable={geolocationEnable}
					showDistance={showDistance}
					isOpen={isOpen}
					layerSide={layerSide}
				/>
			)}
			<StyledClickArea onClick={onFocus} />
		</Selector>
	);
};

export default LocationActivator;

// #####################################################
